import type { DecimalPipe } from '@angular/common';
import type { OnyxOptional } from '@onyx/angular';
import type { UnitRuleField } from '../constants/common/unit-rules';
import { UNIT_RULES } from '../constants/common/unit-rules';
import type { UnitRule, UnitWarning } from '../interfaces/common/unit-rule';

export class UnitWarningHelper {
  public static getWarning(
    value: OnyxOptional<number>,
    field: UnitRuleField,
  ): UnitWarning | null {
    if (!value) return null;

    const { min = 0, max, mistakenUnit }: UnitRule = UNIT_RULES[field];

    const isInRange = (number: number) => number >= min && number <= max;
    if (isInRange(value)) return null;

    if (mistakenUnit) {
      const suggestion = Math.round(value * mistakenUnit.factor);
      if (isInRange(suggestion)) return { key: mistakenUnit.name, suggestion };
    }

    return { key: 'outOfRange', suggestion: null };
  }

  public static format(
    value: number,
    field: UnitRuleField,
    decimalPipe: DecimalPipe,
  ): string {
    const { decimalPlaces } = UNIT_RULES[field];
    return (
      decimalPipe.transform(
        value / 10 ** decimalPlaces,
        `1.0-${decimalPlaces}`,
      ) ?? ''
    );
  }
}
